import axios from '@/libs/api.request'
const goodsRequest = {
  // 要货
  // 报货接口  isPredict是否预估  isOrder是否订单  isSupply是否补货
  setGoodsRequest: (data) => {
    return axios.post({
      url: '/GoodsRequest',
      data: data
    })
  },
  // 判断是否已经存在要货单
  getGoodsRequest: (data) => {
    return axios.get({
      url: '/GoodsRequest?' + axios.parseParams(data)
    })
  },
  // 获取模板列表
  getGoodsRequestTemplate: (data) => {
    return axios.get({
      url: '/GoodsRequest/template?' + axios.parseParams(data)
    })
  }
}
export default goodsRequest



// WEBPACK FOOTER //
// ./src/api/api-goodsRequest.js